import { useScroll } from "@/hooks/use-scroll";
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";
import { ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

export const StickyHeader = ():JSX.Element => {
  const isScrolled = useScroll();
  const [width, setWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 0
  );

  useEffect(() => {
    const handleResize = (): void => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const isDesktop = width > 640;

  return (
    <motion.div
      className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md shadow-sm"
      initial={{ y: -100 }}
      animate={{ y: isScrolled ? 0 : -100 }}
      transition={{ duration: 0.3 }}
    >
      <div className="container mx-auto px-4 py-3 flex justify-between items-center">
          <Link to="/">
        <img
          src="/lovable-uploads/a640d2a4-f462-47db-aaa6-331b0e57fec0.png"
          alt="Woost"
          className="h-12"
        />
        </Link>
        <div className="flex gap-4">
          <a
            href="https://play.google.com/store/apps/details?id=com.woost"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden sm:block"
          >
            <Button variant="outline" className="flex items-center gap-2">
              <span>Download App</span>
              <ExternalLink size={16} />
            </Button>
          </a>
          {isDesktop && (
            <Button
              onClick={() => {
                const contactSection = document.getElementById("contact");
                if (contactSection) {
                  contactSection.scrollIntoView({ behavior: "smooth" });
                }
              }}
              className="bg-woost-blue hover:bg-woost-blue-dark"
            >
              Get in Touch
            </Button>
          )}

          <Link to="https://partners.woost.io" target="_blank">
            <Button className="bg-woost-blue hover:bg-woost-blue-dark">
              Dashboard
            </Button>
          </Link>
          <Link to="/blog">
            <Button className="bg-woost-blue hover:bg-woost-blue-dark">
              Blog
            </Button>
          </Link>
        </div>
      </div>
    </motion.div>
  );
};
